import { api } from "../../../store/api";
import { Option } from "../../../store/types";
import {
  CacheFlow,
  FinancialPLItem,
  FinDetailResponse,
  FinOption,
  Leftover,
} from "./types";

export const financialApi = api.injectEndpoints({
  endpoints: (build) => ({
    finGetTypes: build.query<Option[], void>({
      query: () => ({
        url: "/finance/listAccTypes",
        method: "GET",
      }),
      transformResponse: (data: any) => {
        return data.listAccTypes.map((i: FinOption) => ({
          label: i.name,
          value: i.id,
        }));
      },
    }),
    finGetCompanies: build.query<Option[], void>({
      query: () => ({
        url: "/finance/listCompanies",
        method: "GET",
      }),
      transformResponse: (data: any) => {
        return data.listCompanies.map((i: FinOption) => ({
          label: i.name,
          value: i.id,
        }));
      },
    }),
    finGetLeftovers: build.query<Leftover[], { params: string }>({
      query: ({ params }) => ({
        url: `/finance/balances?${params}`,
        method: "GET",
      }),
      keepUnusedDataFor: 0,
      providesTags: ["FinGetLeftovers"],
      transformResponse: (data: any) => {
        return data.balances;
      },
    }),
    getFinancialCaheflow: build.query<
      { cashflow: CacheFlow[] },
      { params: string }
    >({
      query: ({ params }) => ({
        url: `/finance/cashflow?${params}`,
        method: "GET",
      }),
      keepUnusedDataFor: 0,
    }),
    getFinancialPL: build.query<
      { pAndL: FinancialPLItem[] },
      { params: string }
    >({
      query: ({ params }) => ({
        url: `/finance/pAndL?${params}`,
        method: "GET",
      }),
      keepUnusedDataFor: 0,
    }),
    getDetails: build.query<FinDetailResponse, { params: string }>({
      query: ({ params }) => ({
        url: `/finance/cashflowDetail?${params}`,
        method: "GET",
      }),
      keepUnusedDataFor: 0,
    }),
    getDetailsPL: build.query<FinDetailResponse, { params: string }>({
      query: ({ params }) => ({
        url: `/finance/pAndLDetail?${params}`,
        method: "GET",
      }),
      keepUnusedDataFor: 0,
    }),
  }),
  overrideExisting: true,
});

export const {
  useFinGetTypesQuery,
  useFinGetCompaniesQuery,
  useLazyFinGetLeftoversQuery,
  useLazyGetFinancialCaheflowQuery,
  useLazyGetFinancialPLQuery,
  useGetDetailsQuery,
  useGetDetailsPLQuery,
} = financialApi;
